import type { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { StackedLayout } from '@/primitives/stacked-layout.tsx';
import { useAuth } from '../hooks/auth-provider.tsx';
import ImpersonationBanner from './impersonation-banner.tsx';
import LayoutNavBar from './layout-nav-bar.tsx';
import LayoutSideBar from './layout-side-bar.tsx';

const Layout: FC = () => {
  const { isImpersonating } = useAuth();

  return (
    <>
      {isImpersonating && <ImpersonationBanner />}
      <StackedLayout navbar={<LayoutNavBar />} sidebar={<LayoutSideBar />}>
        <Outlet />
      </StackedLayout>
    </>
  );
};

export default Layout;
